import styled from 'styled-components';

import { ValidityFieldFormInterface } from '../../Models/Common/FormFieldComponentInterfaces';

import { useLicenseHook } from '../../Hooks/License/licenseHooks';

import { CachingEnum } from '../../Utilities/Enums/CachingEnum';

import AutoCompleteDropdown from './AutoCompleteDropdown';
import FormTextField from './FormTextField';

const FormValidityFieldContainer = styled.div <{ $isHiddenLabel?: boolean; }>`
    width: -webkit-fill-available;
    display: grid;
    grid-template-columns: 3fr 1.3fr;
    // align-items: end;

    .formTextFieldContainer {
        width: 100% !important;
        .MuiFormControl-root.MuiFormControl-marginNormal.MuiFormControl-fullWidth.MuiTextField-root {
            .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-sizeSmall {
                height: 34px;

                .MuiOutlinedInput-notchedOutline {
                    border-radius: 4px 0px 0px 4px;
                    border-right: none;
                }
            }
        }
    }

    .autoCompleteDropdownContainer {
        margin: ${(props) => (props.$isHiddenLabel ? '0px 0px 0px 0px' : '23px 0px 0px 0px')} !important;
        // margin: 20px 0px 0px 0px;
        width: 100% !important;

        .MuiAutocomplete-root.MuiAutocomplete-hasPopupIcon {
            .MuiFormControl-root.MuiFormControl-fullWidth.MuiTextField-root {
                .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot {
                    height: 34px;

                    .MuiOutlinedInput-notchedOutline {
                        border-radius: 0px 4px 4px 0px;
                    }
                }
            }
        }
    }
`;

export default function FormValidityField(fieldProps: ValidityFieldFormInterface) {
    const { DropdownData, dropdownFetchStatus } = useLicenseHook([CachingEnum.VALIDITY_TYPE_LIST], null, false);
    let _errorMessages = {
        ...fieldProps?.errorMessages,
        [fieldProps.validityName] : fieldProps?.errorMessages?.[fieldProps.validityName] != null && fieldProps?.errorMessages?.[fieldProps.validityName] != "" ?
            fieldProps?.errorMessages?.[fieldProps.validityName] : (fieldProps?.errorMessages?.[fieldProps.validityTypeName] ?? ""),
        [fieldProps.validityTypeName] : fieldProps?.errorMessages?.[fieldProps.validityName] != null && fieldProps?.errorMessages?.[fieldProps.validityName] != "" ?
            fieldProps?.errorMessages?.[fieldProps.validityName] : (fieldProps?.errorMessages?.[fieldProps.validityTypeName] ?? "")
    };

    const validityProps = {
        name: fieldProps.validityName,
        title: fieldProps.validityTitle,
        fieldValue: fieldProps?.validityValue ?? 0,
        type: 'number',
        hideLabel: fieldProps?.hideLabel ?? false,
        required: fieldProps?.validityRequired ?? false,
        disabled: fieldProps?.disabled ?? false,
        errorMessages: _errorMessages,
        handleOnChange: (selectedValue: any) => {
            if(fieldProps.validityHandleOnChange) {
                fieldProps.validityHandleOnChange(selectedValue);
            }
        },
    },
        validityTypeProps = {
            name: fieldProps.validityTypeName,
            title: '',
            fieldValue: fieldProps?.validityTypeValue ?? "",
            options: DropdownData[CachingEnum.VALIDITY_TYPE_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus ?? false,
            disabled: fieldProps?.disabled ?? false,
            required: false,
            errorMessages: _errorMessages,
            hideErrorMessage: true,
            hideLabel: true,
            handleOnChange: (selectedValue: any) => {
                if(fieldProps.validityTypeHandleOnChange) {
                    fieldProps.validityTypeHandleOnChange(selectedValue);
                }
            },
        };


    return <FormValidityFieldContainer $isHiddenLabel={fieldProps?.hideLabel ?? false} className={"formValidityFieldContainer " + fieldProps?.fieldClassName ?? ""}>
        <FormTextField {...validityProps} />
        <AutoCompleteDropdown {...validityTypeProps} />
    </FormValidityFieldContainer>;

}